import React, { useEffect, useState } from "react";
import PageTitle from "../store/PageTitle";
import Header from "./Header";
import Products from "./Products";
import Ads from "./Ads";
import Loader from "./Loader";
import { fetchAds } from "../store/action/adsAction";
import { useDispatch, useSelector } from "react-redux";
import Cart from "../checkout/Cart";
import HighLightedProducts from "./HighLightedProducts";
import "./home.css";
import "./style.css";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const api = {
  fetchHighLight: async () => {
    const response = await fetch(`${serverUrl}/highlights-client`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch highlights");
    }
    return await response.json();
  },
};

function Home({
  toggleLogin,
  products,
  loading,
  error,
  isCartOpen,
  toggleCart,
  closeCart,
  showProducts,
  setShowProducts,
  closeCartRef,
  currentPage,
  setCurrentPage,
  activeCategory,
  setActiveCategory,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAds());
  }, [dispatch]);

  const { ads } = useSelector((state) => state.ads);

  // Filter banner ads for Header
  const bannerAds = ads
    ? ads.filter((ad) => ad.position === "banner" && ad.is_active)
    : [];

  // Filter footer ads for Ads component
  const footerAds = ads
    ? ads.filter((ad) => ad.position === "footer" && ad.is_active)
    : [];

  const [highlights, setHighlights] = useState([]);

  useEffect(() => {
    fetchHighLight();
  }, []);

  const [highloader, setHighLoader] = useState(false);

  const fetchHighLight = async () => {
    setHighLoader(true);
    try {
      const data = await api.fetchHighLight();
      setHighlights(data || []);
    } catch (err) {
      console.error("Error fetching Highlights:", err);
    } finally {
      setHighLoader(false);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  // Handler for featured card clicks
  const handleFeaturedClick = (category, productName) => {
    setShowProducts(true);
    setActiveCategory(category);
    setSearchTerm(productName);
  };

  const handleShowAllProducts = () => {
    setShowProducts(true);
    setActiveCategory("All");
    setSearchTerm("");
  };

  const handleCloseProducts = () => {
    setShowProducts(false);
    setActiveCategory("All");
    setSearchTerm("");
  };

  const handleBackToProducts = () => {
    setShowProducts(true); // Stay in products view
    // Optionally reset search/category if needed
  };

  return (
    <div>
      <PageTitle title="City Gamers & Electronics" />
      <div>
        <Header ads={bannerAds} />
        {isCartOpen && (
          <Cart
            closeCart={closeCart}
            toggleLogin={toggleLogin}
            closeCartRef={closeCartRef}
          />
        )}
        {!showProducts && (
          <HighLightedProducts
            products={highlights}
            onFeaturedClick={handleFeaturedClick}
            highloader={highloader}
            handleShowAllProducts={handleShowAllProducts}
          />
        )}
        {showProducts && (
          <Products
            products={products}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            loading={loading}
            error={error}
            onClose={handleCloseProducts}
            onBackToProducts={handleBackToProducts}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}

        <Ads ads={footerAds} />
        {loading && <Loader />}
      </div>
    </div>
  );
}

export default Home;
